import CommonMixin from "@/common/mixins/common-mixin";
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

export default {
    mixins: [CommonMixin],
    data() {
        return {
            is_loading: false,
            single: {
                duration: 30,
                meeting_date: new Date().Format("yyyy-MM-dd"),
                meeting_time: '00:00',
                option_mute: '1',
                option_jbh: '1',
                option_h323: '0',
                group_id: null,
                usage: '办公',
                is_recurrent:0,
                recurrent_id:0,
                end_meeting_date: new Date().Format("yyyy-MM-dd"),
                end_meeting_times:2,
                repeat_type:2,
                size: 100,
                auto_record: 0,
                assistant: '',
                option_enroll: '0',
                enroll_attendees: '',
                enroll_questions: [],
                enroll_selection:[],
                option_water_mark: '1',
                option_sso_only: '0',
                meeting_guests: "",
                label:[],
            },
            enroll_search:{
                search:'',
            },
            enroll_data: [],
            enroll_question_list: [
                {id: 2, question: '手机号'},
                {id: 3, question: '邮箱'},
                {id: 4, question: '姓名'},
                {id: 5, question: '公司名称'},
            ],
            fields: {},
            emails: [],
            address_book_visible: false,
            old_data: {
                date: null,
                time: null,
                duration: null,
                password: null,
            },
            page_ready: false,
            sizes: [100, 200, 300],
            repeat_options:[{name:'每日循环',value:1},{name:'每周循环',value:2},{name:'每月循环',value:3}],
            edit_tab: '1',
        }
    },
    filters:{
        enrollAnswer(enroll, question) {
            const answers = enroll.answer_list;
            if (answers && answers.length) {
                for (let i = 0; i < answers.length; i++) {
                    if (answers[i].question_title === question) {
                        return answers[i].answer_content.join(',');
                    }
                }
            }
            return '';
        },
    },
    computed: {
        enrollDataFiltered(){
          if (this.enroll_data) {
              const search = this.enroll_search.search;
              if (search.length) {
                  return this.enroll_data.filter(item => {
                      console.log('item',search,item);
                      if (item.nick_name && item.nick_name.indexOf(search) > -1)  return true;
                      if (item.userid && item.userid.indexOf(search) > -1)  return true;
                      const answers = item.answer_list;
                      if (answers && answers.length) {
                          for (let i = 0; i < answers.length; i++) {
                              const x = answers[i].answer_content.join(',');
                              if ( x.indexOf(search) > -1) return true;
                          }
                      }
                      return false;
                  });
              } else {
                  return this.enroll_data;
              }
          }
          return [];
        },
        approveType() {
            if (this.single.approve_status == '批准') {
                return 'success';
            } else if (this.single.approve_status == '拒绝') {
                return 'danger';
            } else if (this.single.approve_status == '提交') {
                return 'primary';
            } else {
                return 'info';
            }
        },
        approveIcon() {
            if (this.single.approve_status == '批准') {
                return 'el-icon-check';
            } else if (this.single.approve_status == '拒绝') {
                return 'el-icon-close';
            } else if (this.single.approve_status == '提交') {
                return 'el-icon-s-promotion';
            } else {
                return 'el-icon-document-add';
            }
        },
        editRules() {
            let rules = {};
            for (let x in this.fields) {
                const field = this.fields[x];
                if (field.validation) {
                    rules[x] = [];
                    field.validation.forEach(item => {
                        const trigger = ['text', 'textarea', 'number'].includes(item.type) ? 'blur' : 'change';
                        if (item === 'required') {
                            rules[x].push({
                                required: true,
                                message: this.english ? ((field.title_en || field.title) + " is required!") : ('请输入' + field.title),
                                trigger: trigger
                            });
                        }
                        if (item.indexOf('min:') === 0 || item.indexOf('max:') === 0) {
                            let cmd = item.split(':');
                            if (cmd.length > 1) {
                                let v = {
                                    message: (cmd[0] === 'min' ? ('最小') : ('最大')) + cmd[1] + ('个字'),
                                    trigger: 'blur'
                                };
                                v[cmd[0]] = parseInt(cmd[1]);
                                rules[x].push(v);
                            }
                        }
                        if (item.indexOf('email') === 0) {
                            rules[x].push({
                                type: 'email',
                                message: ('请输入正确的邮箱格式'),
                                trigger: trigger
                            });
                        }
                    });
                }
            }
            return rules;
        },
        canAdd() {
            let can = true;
            const level = parseInt(this.user.role_level);
            if (this.preset.app.create_meeting_forbidden) {
                if (level < 3) {
                    can = false;
                }
            }
            return can;
        },
        join_meeting_at() {
            const meeting_start = this.single.meeting_date + ' ' + this.single.meeting_time;
            let d = this.$dateParse(meeting_start, true);
            d.setMinutes(d.getMinutes() - 20);
            return d.Format('yyyy-MM-dd hh:mm');
        },
        end_meeting_at() {
            const meeting_start = this.single.meeting_date + ' ' + this.single.meeting_time;
            let d = this.$dateParse(meeting_start, true);
            d.setMinutes(d.getMinutes() + 10 + this.single.duration);
            return d.Format('yyyy-MM-dd hh:mm');
        },
        meeting_start() {
            return this.single.meeting_date + ' ' + this.single.meeting_time;
        },
        need_approval() {
            return this.single.id === 0 || this.single.meeting_date !== this.old_data.meeting_date ||
                (this.single.meeting_time + ':00' !== this.old_data.meeting_time &&
                    this.single.meeting_time !== this.old_data.meeting_time) ||
                this.single.duration !== this.old_data.duration || this.single.approve_status === '拒绝';
        },
        allRoomGroups() {
            const allow = this.user ? [...this.user.allow_room_group] : [];
            const all = this.preset.app ? this.preset.app.room_groups : [];
            if (!allow || !all) return [];
            if (this.single && !allow.includes(this.single.group_id)) {
                allow.push(this.single.group_id);
            }
            return all.filter((t) => {
                return allow.includes(t.id)
            });
        },
        duration_options() {
            const options = [];
            for (let i = 0.5; i <= this.preset.app.max_hours; i += 0.5) {
                options.push({label: i + '小时', value: i * 60})
            }
            return options;
        },
        isWelinkMeeting() {
            return this.roomGroupPlatform === 4;
        },
        isZoom() {
            return [0, 2, 3].includes(this.roomGroupPlatform);
        },
        isTencentMeeting() {
            return this.roomGroupPlatform === 1;
        },
        roomGroupPlatform() {
            let platform = 0;
            if (this.preset.app.room_groups) {
                this.preset.app.room_groups.forEach((x) => {
                    if (x.id === this.single.group_id) platform = x.platform;
                })
            }
            return platform;
        },
        invisible() {
            return this.$organization.org === 'sjtu';
        },
        allow_recurrent_book() {
            return !!this.preset.app && this.preset.app.allow_recurrent_book;
        }
    },
    methods: {
        handleEnrollOptionChange() {
            if (this.single.option_enroll == 1) {
                this.old_data.password = this.single.password;
                this.single.password = '';
            } else {
                this.single.password = this.old_data.password;
            }
        },
        approveEnroll(action) {
            const data = this.enroll_selection.map(x => x.enroll_id);
            console.log(data)
            if (!data.length) {
                this.$notice.error('请至少选择一位报名者!');
            } else {
                this.$api('Meeting.Enroll.Approve',{id:this.single.id,action:action,enroll_ids:data}).then((res)=>{
                    this.$notice.success('操作成功!');
                    this.enroll_data = res.data.data;
                });
            }
        },
        tableFilterHandler(value, row, column) {
            console.log(value,row,column);
            const property = column['property'];
            return row[property] == value;
        },
        handleSelectionChange(val){
            this.enroll_selection = val;
        },
        handleSubmitEnroll(){
            if (this.single.id === 0) {
                this.$notice.error('需要先保存会议才能进行设置报名信息!');
            } else {
                this.$api('Meeting.Enroll.Update',this.single,true).then(()=>{
                    this.$notice.success('更新完毕!');
                });
            }
        },
        loadEnrollData() {
            if (!this.single.id) {
                this.$notice.error('请先保存会议，才可以获取报名信息!');
            } else {
                this.$api('Meeting.Enroll.SearchParticipants', {id: this.single.id}, true).then(res => {
                    this.enroll_data = res.data.data;
                })
            }
        },
        exportEnrollData() {
            if (this.enroll_data.length > 0) {
                this.exportExcel('报名信息');
            } else {
                this.$notice.error('没有报名信息，请先载入!');
            }
        },
        exportExcel(name) {
            /* generate workbook object from table */
            let wb = XLSX.utils.table_to_book(this.$refs['excel_table'], {raw: true});
            /* get binary string as output */
            let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
            let now = new Date().Format('yyyy-MM-dd');
            try {
                FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), `${name}-${now}.xlsx`)
            } catch (e) {
                console.log(e, wbout)
            }
            return wbout
        },
        handleSubmit() {
            let vm = this;
            this.$refs['MeetingForm'].validate(valid => {
                if (valid) {
                    vm.is_loading = true;
                    vm.single.attendees = JSON.stringify(vm.emails);
                    vm.$api('Meeting.Edit', Object.assign({}, vm.single, {ask: 1}), true).then((res) => {
                        vm.is_loading = false;
                        if (res.data.data === 'CONFIRM') { // 确认后再次调用
                            vm.$affirm('此次操作将会变更会议号码，请确定是否继续?').then(() => {
                                vm.$api('Meeting.Edit', vm.single, true).then(() => {
                                    vm.is_loading = false;
                                    this.$alert('会议已经成功保存。返回我的会议查看', '成功', {
                                        confirmButtonText: '确定',
                                        type: 'success'
                                    });
                                    vm.$router.push(this.$organization.home_page);
                                }).catch(() => {
                                    vm.is_loading = false;
                                    vm.$refs['meeting_busy'].queryBF();
                                });
                            });
                        } else {
                            this.$alert('会议已经成功保存。返回我的会议查看', '成功', {
                                confirmButtonText: '确定',
                                type: 'success'
                            });
                            vm.$router.push(this.$organization.home_page);
                        }
                    }).catch(() => {
                        vm.is_loading = false;
                        vm.$refs['meeting_busy'].queryBF();
                    });
                } else {
                    this.$notify({
                        title: '错误',
                        message: '请按照指示填写正确的信息',
                        type: 'error'
                    });
                    return false;
                }
            });
        },
        handleFreeChange(item) {
            this.single.meeting_date = item.date;
            this.single.meeting_time = item.time;
        },
        handleAddressBook() {
            this.address_book_visible = true;
        },
        handleCancel() {
            this.address_book_visible = false;
        },
        handleSuccess(val) {
            this.address_book_visible = false;
            this.emails = val;
        },
        removeEmail(val) {
            const index = this.emails.indexOf(val);
            if (index >= 0) this.emails.splice(index, 1);
        },
        importEmails(import_text) {
            this.emails = [];
            try {
                let data = JSON.parse(import_text);
                if (Array.isArray(data)) {
                    this.emails = data;
                }
            } catch (e) {
                console.log(e);
            }
        },
        makeRandomPassword() {
            this.$set(this.single, 'password', Math.round(900000 * Math.random() + 100000));
        },
        processData() {
        },
        checkCreateMeetingForbidden() {
            if (this.preset.app.create_meeting_forbidden && this.user.role_level < 3) {
                if (this.preset.app.create_meeting_forbidden_redirect) {
                    window.location.href = this.preset.app.create_meeting_forbidden_redirect;
                } else {
                    this.$notice.error(this.preset.app.create_meeting_forbidden_message);
                    this.$router.go(-1);
                }
            } else {
                this.page_ready = true;
            }
        }
    },
    created() {
        const vm = this;
        if (!this.$route.params.id) {
            //判断是否可以建会
            if (this.preset.app.name) {
                this.checkCreateMeetingForbidden();
            } else {
                const timer = setInterval(() => {
                    if (vm.preset.app.name) {
                        clearInterval(timer);
                        vm.checkCreateMeetingForbidden();
                    }
                }, 500);
            }
        } else {
            this.page_ready = true;
        }
    },
    mounted() {
        let vm = this;
        let date;
        if (!this.$route.params.id) {
            const allow = this.user ? this.user.allow_room_group : [];
            let default_group = null;
            if (allow && allow.length) {
                default_group = allow[0];
                if (this.$organization.no_default_group) {
                    default_group = null;
                }
            }
            const data = {
                duration: 30,
                option_mute: '1',
                option_jbh: '1',
                auto_record: this.$organization.auto_record,
                waiting_room: '0',
                id: 0,
                quite: true,
                group_id: default_group,
                usage: '办公',
                size: 100,
                option_enroll: '0',
                enroll_attendees: '',
                enroll_questions: [],
            };

            if (this.$route.params.start && this.$route.params.end) {
                date = this.$route.params.start;
                const min = date.getMinutes();
                let new_min = Math.floor((min + 15) / 30) * 30;
                date.setMinutes(new_min);
                data.duration = Math.floor((this.$route.params.end - this.$route.params.start) / 60000);
                console.log(data.duration);
                data.duration = Math.floor((data.duration) / 30) * 30;
            } else {
                date = new Date();
                const min = date.getMinutes();
                let new_min = Math.floor((min + 30) / 30) * 30;
                date.setMinutes(new_min);
            }

            data.meeting_date = date.Format('yyyy-MM-dd');
            data.meeting_time = date.Format('hh:mm');

            vm.single = Object.assign({}, vm.single, data);

            vm.old_data.meeting_date = '';
            vm.old_data.meeting_time = '';
            vm.old_data.duration = 0;
            // 新建 自动加密码
            this.makeRandomPassword();
            vm.old_data.password = this.single.password;
            if (this.single.option_enroll == 1) this.single.password = '';

        } else {
            this.$api('Meeting.Get', {id: this.$route.params.id}).then(res => {
                if (res.data.success) {
                    const data = res.data.data.data;
                    data.duration = parseInt(data.duration);
                    data.auto_record = parseInt(data.auto_record);
                    data.waiting_room = parseInt(data.waiting_room);
                    data.quite = !!parseInt(data.quite);
                    data.group_id = parseInt(data.group_id);

                    vm.single = data;
                    this.$set(this, 'fields', res.data.data.fields);
                    this.processData();

                    vm.old_data.meeting_date = data.meeting_date;
                    vm.old_data.meeting_time = data.meeting_time;
                    vm.old_data.duration = data.duration;
                    vm.old_data.password = this.single.password;
                    vm.importEmails(data.attendees);

                    if (this.single.option_enroll == 1) this.single.password = '';

                } else {
                    const text = res.data.text;
                    vm.$alert(text, '错误', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: () => {
                            vm.$router.replace(vm.$organization.home_page);
                        }
                    });
                }
            }).catch(() => {
                vm.$router.go(-1);
            });
        }
    },
}
